export const DefaultScores = {
    Ml360MaxScore: 7,
    SelfDeterminationMaxScore: 5,
    GrowthMindsetMaxScore: 5,
    OrganisationalAiReadinessMaxScore: 5,
    TeamResilienceMaxScore: 100,
    DefaultAverageScore: 0,
};

export const MetricLabels = {
    RunTime: '2.4km Run Time (mm:ss)',
};
